export default "__VITE_ASSET__C3HQQjpa__"